<template>
  <div class="bb-tracking-table" v-click-outside="resetEditableRow">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"></loader-fly>
    </transition>
    <div class="bb-tracking-table-row bb-tracking-table-row_header"
         @click="resetEditableRow"
         :style="columnsGrid">
      <div class="bb-tracking-table-row-cell bb-tracking-table-row-cell_header"
           :class="{
             'bb-tracking-table-row-cell_header_pointer': column.filters,
             'bb-tracking-table-row-cell_header_center': column.center
           }"
           @click="clickHeader(column)"
           @mouseleave="openFilter = false"
           v-for="column in columns"
           :key="column.id">
        <template v-if="column.type === 'checkbox'">
          <checkbox :animation="true"
                    :choseChecked="choseChecked"
                    :value="checkboxValue"
                    @checkboxChange="checkedAll"/>
          <i @click="openChose = !openChose"
             class="icon-arrow-select bb-tracking-table-row-cell-filter"
             :class="{'bb-tracking-table-row-cell-filter_active': openChose}"/>
          <transition  name="fade-form">
            <div class="bb-tracking-table-row-cell-filter-popup
                        bb-tracking-table-row-cell-filter-popup_start"
                 v-if="openChose"
                 @mouseleave="openChose = false"
            >
              <PopupList :options="listCheckbox"
                         @clickItem="clickItem"/>
            </div>
          </transition>
        </template>
        <template v-else>
          <span
            v-if="column.isIconCalendar"
            v-html="calendarIcon"
            class="bb-tracking-table-row-cell__icon"
          />
          <span>{{ column.title }}</span>
        </template>
        <i class="icon-arrow-select bb-tracking-table-row-cell-filter"
           :class="{'bb-tracking-table-row-cell-filter_active': openFilter === column.id}"

           v-if="column.filters || column.filterType"/>
        <transition name="fade-form">
          <FilterPopup class="bb-tracking-table-row-cell-filter-popup"
                       v-if="!column.filterType"
                       v-show="openFilter === column.id"
                       :list="column.filters"
                       :section="column"
                       @setData="setDataFilter"
          />
          <div class="bb-tracking-table-row-cell-filter-popup bb-tracking-table-row-cell-filter-popup_date"
               v-else-if="column.filterType === 'date'"
               v-show="openFilter === column.id">
            <DataPicker class="bb-tracking-table-row-cell-filter-popup__date-picker"
                        @setDate="setDate"
                        :range="'range'"
                        :obj="column"
                        :format="column.format || null"
                        :maskTitle="column.maskTitle || null"
                        :disablePopupHeaderClick="column.disablePopupHeaderClick || null"
            />
            <i class="icon-cross bb-tracking-table-row-cell-filter-popup__clear-date" @click="setDate({}, column)"/>
          </div>
          <div class="bb-tracking-table-row-cell-filter-popup bb-tracking-table-row-cell-filter-popup_date"
               v-else-if="column.filterType === 'many'"
               v-show="openFilter === column.id">
            <FilterExtraParameters
              @setFilter="setExtraFilter"
              @languageFilter="setLanguageFilter"
              :showLanguages="showLanguages"
              :showList="showList"
              :filters="filters"
              :openFilter="openFilter"
            />
          </div>
        </transition>
      </div>
    </div>
    <div class="bb-tracking-table-row"
         :class="{'bb-tracking-table-row_active': hoverRow === row.id}"
         @mouseleave="hoverRow = false"
         @mouseenter="hoverRow = row.id"
         :style="columnsGrid"
         v-for="(row, index) in rows"
         :key="row.id">
      <div class="bb-tracking-table-row-cell"
           :class="{
             'bb-tracking-table-row-cell_capitalize': column.capitalize,
             'bb-tracking-table-row-cell_pointer': column.route
           }"
           @click="clickCell(row, column)"
           v-for="column in columns"
           :key="column.id">
        <template v-if="column.type === 'date'">
          <div class="bb-tracking-table-row-cell-date" v-if="editableRow === row.id && column.editable === true">
            <DataPicker @setDate="setExpDate"
                        :no-past="true"
                        :obj="{row, column}"
                        :default-date="getValue(row, column)"/>
          </div>
          <div v-else>
            {{ getFormattedDate(row, column) }}
          </div>
        </template>
        <template v-else-if="column.type === 'country'">
          <div class="bb-tracking-table-row-cell-country">
            <CountryFlag :country-id="getCountryId(row, column)" v-if="getValue(row, column)"/>
          </div>
        </template>
        <template v-else-if="column.type === 'id'">
          {{ getNameById(row, column, column.prop) }}
        </template>
        <template v-else-if="column.type === 'birthday'">
          {{ getFormattedDate(row, column, 'birthday') }}
        </template>
        <template v-else-if="column.type === 'file' && getValue(row, column)">
          <i class="icon-eye bb-icon bb-icon_accent" @click="openFile(getValue(row, column))"/>
        </template>
        <template v-else-if="column.type === 'status'">
          <div v-if="false" class="bb-tracking-table-row-cell-select" @click.stop>
            <BBSelect label="name"
                      placeholder="Set status"
                      :searchable="false"
                      :options="statusList"
                      :clearable="false"
                      :value="getStatusName(row, column)"
                      @change="setStatus($event, row, column)"/>
          </div>
          <div class="bb-tracking-table-row-cell-status"
               :class="['bb-tracking-table-row-cell-status_' + getStatusName(row, column).className]">
            {{ getStatusName(row, column).name }}
          </div>
        </template>
        <template v-else-if="column.type === 'array'">
          <div class="bb-tracking-table-row-cell-array">
            <div v-for="(item, index) in getValue(row, column)" :key="column.id + index + item[column.label]">
              {{ column.isSimpleShow ? item[column.label] : getNameById(item, column, column.label) }}
            </div>
          </div>
        </template>
        <template v-else-if="column.type === 'arrayPrimitive'">
          <div class="bb-tracking-table-row-cell-array">
            <div v-for="(item, index) in getValue(row, column)" :key="column.id + index + item">
              {{ item }}
            </div>
          </div>
        </template>
        <template v-else-if="column.type === 'comment'">
          <div class="bb-tracking-table-row-cell-form" v-if="editableRow === row.id" @click.stop>
            <input class="bb-input bb-input_border bb-tracking-table-row-cell-form__input"
                   @keyup.enter="saveRow(row)"
                   v-autofocus
                   @keyup.esc="resetEditableRow()"
                   v-model="comment"
                   type="text">
          </div>
          <div v-else>{{ getValue(row, column) }}</div>
        </template>
        <template v-else-if="column.type === 'toolbar'">
          <transition name="bounce">
            <div class="bb-tracking-table-row-cell"
                 v-if="displayEditRow(row, column)"
                 @click.stop="setEditableRow(row, column)">
              <i class="icon-edit bb-icon bb-icon_accent"/>
            </div>
          </transition>
        </template>
        <template v-else-if="column.type === 'checkbox'">
          <checkbox :name="row.id"
                    :animation="true"
                    :section="row"
                    :value="checkedRowsIds.includes(row.id)"
                    @checkboxChange="changeCheckedRows"/>
        </template>
        <template v-else-if="column.type === 'toggleWithWarning'">
          <ToggleCellTrackingTable
            :item="row[column.prop]"
            @changeToggle="(value) => changeToggledRows(value, row)"
          />
        </template>
        <template v-else-if="column.type === 'index'">
          <div class="bb-table-counter">
            <span class="bb-table-counter__number">{{(index + 1) + (page.defLimit * (page.currentPage - 1))}}</span>
          </div>
        </template>
        <template v-else-if="column.type === 'pre'">
          <pre class="bb-tracking-table-row-cell__pre">
            {{ getValue(row, column) }}
          </pre>
        </template>
        <template v-else-if="column.type === 'tax'">
          <div
            v-if="getValueTax(row, column)"
            class="bb-tracking-table-row-cell__tax"
            @click="setTaxFilter(column)"
          >
            TAX
          </div>
        </template>
        <template v-else>
          {{ getValue(row, column) }}
        </template>
        <template v-if="column.info && getValueInfo(row, column)">
          <i class="icon-info bb-tracking-table-row-cell-info"
             @mouseleave="infoPopup = false"
             @mouseenter="infoPopup = row.id">
            <transition name="bounce">
              <Popup class="bb-tracking-table-row-cell-info__popup"
                     :radio="false"
                     :title="getValueInfo(row, column)"
                     v-if="infoPopup === row.id"
                     @close="infoPopup = false"/>
            </transition>
          </i>
        </template>
        <template v-if="column.file && getFile(row, column)">
          <i class="icon-eye bb-icon bb-icon_accent bb-tracking-table-row-cell__file-icon"
             @click.stop="openFile(getFile(row, column))"/>
        </template>
      </div>
      <button class="bb-button bb-tracking-table-row-cell__button"
              @click="saveRow(row)"
              v-if="editableRow === row.id">
        SAVE
      </button>
    </div>
    <TableNoData explanation="Sorry, no data found." :border="true" v-if="(!rows || rows.length === 0) && noData"/>
  </div>
</template>

<script>
import {get, set, forEach, find} from 'lodash'
import moment from 'moment'
import UploadFileApi from '@/api/UploadFile/api'
import {EXPIRE, expireStatus} from '@/constants/expireStatus'
import TableNoData from '@/components/Main/Table/TableNoData/TableNoData'
import FilterPopup from '@/components/Main/FilterPopup/FilterPopup'
import PopupList from '@/components/Main/PopupList/PopupList'
import Checkbox from '@/components/Main/Inputs/checkbox'
import Popup from '@/components/Main/Popup/Popup'
import DataPicker from '@/components/Main/DataPicker/DataPicker'
import FilterExtraParameters
  from '@/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingTable/FilterExtraParameters'
import CountryFlag from '@/components/Main/CountryFlag/CountryFlag'
import countriesList from '@/constants/countriesList'
import BBSelect from '@/components/Main/Inputs/BBSelect'
import b64toBlob from 'b64-to-blob'
import {saveAs} from 'file-saver'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import { CalendarIcon } from '@/constants/icon'
import ToggleCellTrackingTable from "./ToggleCellTrackingTable/ToggleCellTrackingTable.vue";

export default {
  name: 'ContactsTrackingTable',
  components: {
    CountryFlag,
    FilterExtraParameters,
    Checkbox,
    TableNoData,
    FilterPopup,
    Popup,
    BBSelect,
    PopupList,
    DataPicker,
    LoaderFly,
    ToggleCellTrackingTable,
  },
  props: [
    'columns',
    'showList',
    'showLanguages',
    'page',
    'rows',
    'checkboxValue',
    'listCheckbox',
    'scroll',
    'choseChecked',
    'noData',
    'checkedList',
    'allChecked',
    'status',
    'filters'
  ],
  data () {
    return {
      hoverRow: false,
      openFilter: false,
      openChose: false,
      editableRow: false,
      comment: '',
      infoPopup: false,
      statusList: expireStatus,
      calendarIcon: CalendarIcon(),
      loaderRun: false,
      crypt: true,
      files: {}
    }
  },
  computed: {
    isFounder () {
      // const role = get(this.userInfo, 'role', '')
      return true // role === FOUNDER.id
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    checkedRowsIds () {
      return this.checkedList.map(contact => contact.id)
    },
    columnsGrid () {
      const columns = this.columns || []
      const repeat = columns.map(item => item.width || 'minmax(70px, 1fr)').join(' ')
      return {
        gridTemplateColumns: `${repeat} minmax(50px, 70px)`
      }
    }
  },
  methods: {
    setStatus (data, row, column) {
      const dataId = get(data, 'id', '')
      if (!dataId) return
      set(row, column.prop, dataId)
    },
    checkedAll () {
      this.$emit('getAll')
    },
    getCountryId (row, column) {
      const countryId = get(row, column.prop, '')
      const result = find(countriesList, {id: countryId})
      return get(result, 'id', '')
    },
    changeToggledRows (value, row, ) {
      this.$emit('updateToggle', {value, row})
    },
    changeCheckedRows (value, rowId, row) {
      this.$emit('changeChecked', {value, rowId, row})
    },
    getStatusName (row, column) {
      const status = get(row, column.prop, '')
      const statusObject = find(expireStatus, {id: status})
      const statusName = get(statusObject, 'name', '')
      const statusAltName = get(statusObject, 'alt', statusName)
      const statusClassName = get(statusObject, 'className', '')
      return {
        name: column.alt ? statusAltName : statusName,
        className: statusClassName
      }
    },
    clickItem (item) {
      this.openChose = false
      this.$emit('clickItem', item)
    },
    displayEditRow (row, column) {
      const isRowHover = this.hoverRow === row.id
      const statusProp = get(column, 'status', '')
      const isExpired = get(row, statusProp, '') === EXPIRE.id
      const isNoEditable = this.editableRow !== row.id
      return (isRowHover && isExpired && isNoEditable) || (this.isFounder && isRowHover && isNoEditable)
    },
    setEditableRow (row, column) {
      this.editableRow = row.id
      this.comment = get(row, column.comment, '')
    },
    getValidDate (date) {
      const regex = /\d+[^-]/gmi
      const arrayWithDates = date.match(regex)
      const month = +arrayWithDates[0]
      const day = +arrayWithDates[1]
      const validDate = new Date()
      validDate.setDate(day)
      validDate.setMonth(month - 1)
      return validDate
    },
    getFormattedDate (row, column, type) {
      const format = type === 'birthday' ? 'DD-MMM' : 'DD-MMM-YY'
      const date = get(row, column.prop, '')
      const validDate = type === 'birthday' ? this.getValidDate(date) : date
      const isValid = date && moment(new Date(validDate)).isValid()
      return isValid ? moment(new Date(validDate)).format(format) : ''
    },
    getNameById (row, column, prop) {
      const id = get(row, prop, '');
      const objIds = get(column, 'findIn', []);
      const result = find(objIds, {id: id}) || {};
      return result.name
    },
    clickCell (row, column) {
      if (column.route) {
        const gottenParams = {}
        const pureParams = get(column, 'route.pureParams', {})
        const params = get(column, 'route.params', {})
        const routeName = get(column, 'route.name', {})
        forEach(params, (val, key) => {
          const prop = get(row, val, '')
          set(gottenParams, key, prop)
        })
        Object.assign(gottenParams, pureParams)
        this.$router.push({name: routeName, params: gottenParams})
      }
    },
    getValue (row, column) {
      return get(row, column.prop, '')
    },
    getValueInfo (row, column) {
      return get(row, column.info, '')
    },
    getValueTax (row, {prop}) {
      const { title } = this.status
      if (title === 'actual') return get(row, prop, '')
    },
    getFile (row, column) {
      return get(row, column.file, '')
    },
    resetEditableRow () {
      this.editableRow = false
    },
    clickHeader (col) {
      if (col.filters) {
        this.openFilter = this.openFilter ? false : col.id
      }
    },
    setDataFilter (data, item, column) {
      this.$emit('filter', data, item, column)
    },
    setExtraFilter (value, type, item) {
      this.$emit('extraFilter', value, type, item)
    },
    setTaxFilter (column) {
      const { filter, filterBy } = column
      const trn = this.filters[filterBy.prop] || {}
      const { hasProperty = false } = trn
      this.$emit('extraFilter', !hasProperty, filter, filterBy)
    },
    setLanguageFilter (value, type) {
      this.$emit('languageFilter', value, type)
    },
    setExpDate (date, {row, column}) {
      set(row, column.prop, date)
    },
    setDate (date, column) {
      const formatValue = column.filterId === 'birthday' ? 'MM-DD' : 'YYYY-MM-DD';
      moment().format(formatValue)
      const startDate = get(date, 'start', '')
      const endDate = get(date, 'end', '')
      const dateNow = moment().format(formatValue)
      const startDateFormat = moment(startDate).format(formatValue)
      const endDateFormat = moment(endDate).format(formatValue)
      if (dateNow === startDateFormat && dateNow === endDateFormat) return
      const fullDate = startDate && endDate ? `${startDateFormat};;${endDateFormat}` : ''
      this.$emit('filter', fullDate, '', column)
    },
    saveRow (row) {
      this.$emit('update', {row: row, comment: this.comment})
      this.resetEditableRow()
      this.comment = ''
    },
    openFile (file) {
      const newFile = typeof file === 'string' ? file : file.id
      if (this.files[newFile]) {
        saveAs(this.files[newFile].blob, this.files[newFile].label)
      } else {
        this.loaderRun = true
        UploadFileApi.getFile(newFile, this.crypt)
          .then((resp) => {
            this.loaderRun = false
            const blob = b64toBlob(resp.data.base64, resp.data.type)
            this.files[resp.data.id] = {id: resp.data.id, blob, label: resp.data.label}
            saveAs(blob, resp.data.label)
          })
          .catch((err) => {
            console.error(err)
            this.loaderRun = false
          })
      }
    }
  },
  watch: {
    scroll () {
      this.hoverRow = false
    },
    rows () {
      const scrollBody = get(this.scroll, 'target', {})
      scrollBody.scrollTop = 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";
@import "../../../../../../sass/mixins";

.bb-tracking-table {
  @include global-font;
  display: grid;

  &-row {
    position: relative;
    display: grid;
    align-items: center;
    width: 100%;
    border-top: 1px solid $color-wild-sand;
    min-height: 52px;
    grid-gap: 10px;
    font-size: 13px;
    padding: 8px 15px;
    transition: 0.3s;

    &_active {
      z-index: 4;
      background-color: $color-white;
    }

    &:hover:not(&_header) {
      box-shadow: 0 0 12px rgba($color-black, 0.15);
      border-radius: 0 5px 5px 0;
      border-top-color: transparent;

      &:before {
        width: 4px;
        opacity: 1;
      }
    }

    &:before {
      content: '';
      position: absolute;
      top: -1px;
      left: -4px;
      width: 0;
      opacity: 0;
      height: calc(100% + 2px);
      background-color: $color-accent;
      border-radius: 4px 0 0 4px;
      transition: 0.3s;
    }

    &_header {
      position: sticky;
      top: 0;
      background-color: $color-white;
      z-index: 4;
      color: $color-accent;
      padding: 18px 15px;
      cursor: default;
      border-top: none;
    }

    &-cell {
      position: relative;
      display: inline-flex;
      align-items: center;
      font-weight: 500;
      font-size: 13px;
      line-height: 16px;
      user-select: none;
      word-break: break-word;

      &__icon {
        margin-right: 4px;
      }

      &_header {
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 12px;
        line-height: 14px;

        &_pointer {
          cursor: pointer;
          transition: 0.3s;

          &:hover {
            color: $color-accent-hover;
          }
        }

        &_center {
          text-align: center;
        }
      }

      &_capitalize {
        text-transform: capitalize;
      }

      &_pointer {
        cursor: pointer;
        transition: 0.4s;

        &:hover {
          color: $color-accent-hover;
        }
      }

      &-select {
        height: 30px;
        width: 100%;
        margin-left: -16px;
      }

      &-status {
        display: inline-block;
        border-radius: 3px;
        padding: 4px 5px;

        &_under-renewal {
          color: $color-japanese-laurel;
          background-color: rgba($color-japanese-laurel, 0.2);
        }

        &_to-be-renewed {
          color: $color-la-rioja;
          background-color: rgba($color-la-rioja, 0.2);
        }

        &_expire {
          color: $color-pomegranate;
          background-color: rgba($color-pomegranate, 0.2);
        }

        &_liquidated {
          color: $color-black;
          background-color: rgba($color-black, 0.2);
        }
      }

      &-country {
        height: 22px;
      }

      &-date {
        margin-left: -16px;
      }

      &-form {
        margin-left: -16px;

        &__input {
          font-size: 13px;
        }
      }

      &__tax {
        color: $color-denim;
        padding: 4px 6px 4px 6px;
        border-radius: 4px;
        background: rgba($color-denim, 0.14);
        font-weight: 500;
        font-size: 10px;
        line-height: 12px;
        cursor: pointer;
      }

      &__button {
        white-space: nowrap;
        max-height: 35px;
      }

      &__file-icon {
        margin-left: 7px;
      }

      &__pre {
        white-space: pre-line;
      }

      &-info {
        position: relative;
        font-size: 13px;
        color: $color-silver-chalice;
        cursor: pointer;
        line-height: 1;
        transition: 0.4s;
        margin-left: 7px;

        &__popup {
          padding: 12px 10px 4px 10px;
          color: $color-black;
          user-select: none;
          pointer-events: none;
        }
      }

      &-filter {
        margin-left: 6px;
        width: 20px;
        height: 20px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 5px;
        color: $color-accent;
        cursor: pointer;
        transition: 0.3s;

        &_active {
          transform: rotate(180deg);
        }

        &:hover {
          color: $color-accent-hover;
        }

        &-popup {
          position: absolute;
          top: 19px;
          left: 0;
          border-radius: 5px;
          box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
          background-color: $color-white;
          padding: 0 15px 0;
          z-index: 99;
          white-space: nowrap;

          &_start {
            left: -16px;
            top: 23px;
          }

          &_date {
            display: grid;
            grid-template-columns: auto 30px;
            padding: 15px;
          }

          &__clear-date {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 30px;
            height: 30px;
            min-width: 30px;
            min-height: 30px;
            border-radius: 5px;
            border: 1px solid $color-wild-sand;
            color: $color-accent;
            margin-left: 10px;
            cursor: pointer;

            &:hover {
              color: $color-accent-hover;
            }
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingTable/ContactsTrackingTable.vue